<template>
  <el-tooltip effect="dark" :content="isFullscreen ?'点击退出全屏':'点击展开全屏'" placement="left-end">
    <div class="screenfull saasIcon" @click="click">
      {{ isFullscreen ? '\ueb98' : '\ue8fa' }}
    </div>
  </el-tooltip>

</template>

<script>
import screenfull from 'screenfull'

export default {
  name: 'MyScreenful',
  data() {
    return {
      isFullscreen: false
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.destroy()
  },
  methods: {
    click() {
      if (!screenfull.enabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        })
        return false
      }
      screenfull.toggle(document.getElementById("main-fs"))
      // screenfull.toggle(document.body, { wrap: false })
    },
    change() {
      this.isFullscreen = screenfull.isFullscreen
    },
    init() {
      if (screenfull.enabled) {
        screenfull.on('change', this.change)
      }
    },
    destroy() {
      if (screenfull.enabled) {
        screenfull.off('change', this.change)
      }
    }
  }
}
</script>

<style scoped>
.screenfull {
  display: inline-block;
  cursor: pointer;
  fill: #5a5e66;;
  color: #FFFFFF;
  opacity: 0.15;
  font-size: 30px;
  width: 20px;
  font-weight: 200;
  height: 20px;
  vertical-align: 10px;
}
</style>
